const statusMessages = {
  400: 'Não foi possível processar os dados informados. Revise e tente novamente.',
  401: 'Sua sessão expirou. Faça login novamente para continuar.',
  403: 'Você não tem permissão para realizar esta ação.',
  404: 'O recurso solicitado não foi encontrado.',
  409: 'Não foi possível concluir por conflito de dados. Atualize e tente novamente.',
  422: 'Alguns dados informados são inválidos. Revise os campos e tente novamente.',
  429: 'Muitas tentativas em pouco tempo. Aguarde alguns segundos e tente novamente.'
};

const isTechnicalMessage = (message) => {
  const normalized = String(message || '').trim();
  if (!normalized) {
    return true;
  }

  return /request failed with status code\s*\d{3}/i.test(normalized)
    || /^erro\s*\d{3}\b/i.test(normalized)
    || /^\d{3}\b/.test(normalized)
    || /^http\s*\d{3}\b/i.test(normalized)
    || /^internal server error$/i.test(normalized)
    || /^not found$/i.test(normalized);
};

const fallbackByStatus = (status, fallback) => {
  if (typeof status === 'number') {
    if (statusMessages[status]) {
      return statusMessages[status];
    }

    if (status >= 500) {
      return 'O servidor está indisponível no momento. Tente novamente em instantes.';
    }
  }

  return fallback;
};

export const extractApiErrorMessage = (
  error,
  fallback = 'Não foi possível concluir a operação. Tente novamente.'
) => {
  const status = error?.response?.status;
  const payload = error?.response?.data;
  const rawMessage = payload?.message || (typeof payload === 'string' ? payload : '') || error?.message || '';

  if (!rawMessage || isTechnicalMessage(rawMessage)) {
    return fallbackByStatus(status, fallback);
  }

  return String(rawMessage).trim();
};
